var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './switch.module.scss';
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { COLORS } from 'src/shared/styles/colors';
import { IDENTIFIER_SWITCH } from 'src/ui/components/Input/Switch/constants';
export var Switch = function (props) {
    var _a;
    var label = props.label, isActive = props.isActive, onChange = props.onChange, className = props.className;
    var handleOnChange = function (e) {
        e.stopPropagation();
        onChange(!isActive);
    };
    var switchClassName = classNames(styles.switchWrapper, className);
    var switchElementClassName = classNames(styles.switchElement, (_a = {}, _a[styles.switchElementActivated] = isActive, _a));
    return (_jsxs("div", __assign({ "data-test": IDENTIFIER_SWITCH, className: switchClassName }, { children: [_jsx("span", __assign({ className: styles.switchLabel }, { children: label })), _jsx("div", __assign({ className: switchElementClassName, onClick: handleOnChange }, { children: _jsx("span", __assign({ className: styles.switchTrigger }, { children: _jsx(Icons, { icon: E_ICONS.CHECK, color: COLORS.WHITE }) })) }))] })));
};
